module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_share.f3f39.png";